export default "__VITE_ASSET__CsI1fON1__"